/* eslint-disable implicit-arrow-linebreak */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IBenefitLimitedPrice } from 'src/interfaces';
import BenefitsService from 'src/services/benefits.service';

export const usePatchBenefitLimitedPrices = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation((data: IBenefitLimitedPrice[]) => BenefitsService.patchBenefitLimitedPrices(data), {
    onSuccess: () => {
      AlertAdapter('Limited benefit ranges updated successfully', 'success');
      queryClient.invalidateQueries({ queryKey: ['benefits/limited-prices'] });
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });
  return mutation;
};
